import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';
export const QuoteSwiper = () => {
    new Swiper('.swiper-container', {
        modules: [Navigation, Pagination],
        slidesPerView: 1.2,
        spaceBetween: 10,
        loop: false,
        effect: 'slide',
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            progressbarFillClass: 'swiper-pagination-progressbar-fill',
        },
        breakpoints: {
            640: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 1.7,
            },
            1024: {
                slidesPerView: 2.2,
            },
            1280: {
                slidesPerView: 3,
            },
        },
    });
};
